import classNames from "classnames";
import React, { PropsWithChildren } from "react";

type CardPaddingStyle = "padded" | "compact";
type CardBorderStyle = "none" | "border" | "border-dark" | "shadow";
type CardColor = "default" | "yellow" | "pink";

interface CardProps extends PropsWithChildren {
  cardPaddingType?: CardPaddingStyle;
  cardBorderStyle?: CardBorderStyle;
  cardColor?: CardColor;
}

export const Card: React.FC<CardProps> = ({
  cardBorderStyle = "none",
  cardPaddingType = "padded",
  cardColor,
  children,
}) => {
  const cardClasses = classNames("card", {
    "card--compact": cardPaddingType === "compact",
    [`card--${cardBorderStyle}`]: cardBorderStyle !== "none",
    [`background--${cardColor}`]: cardColor,
  });

  return <section className={cardClasses}>{children}</section>;
};
